// extracted by mini-css-extract-plugin
export default {"background":"background_background__ZvsTk","appear":"background_appear__ZORlT","title":"background_title__H87FY"};